import React from 'react'
import LazyLoad from 'react-lazyload'
import Testimonial1 from '../media/images/testimonial1.png'

const Image = props => {
  const { src, alt, width, height, className } = props
  return (
    <LazyLoad height={100} throttle={200}>
      <img
        className={className}
        src={src}
        alt={alt}
        width={width}
        height={height}
      />
    </LazyLoad>
  )
}

const ContactHp = () => (
  <div
    className="row contact_hp"
    style={{ background: '#624dd6', marginTop: '160px' }}
  >
    <div className="single_image">
      <figure className="wpb_wrapper vc_figure">
        <div className="vc_single_image-wrapper vc_box_border_grey">
          <Image width="237" height="216" src={Testimonial1} className="vc_single_image-img attachment-full" alt="Zapisz swoją pociechę" />
        </div>
      </figure>
    </div>
    <h2 className="csm_heading csm_heading_contact">
      Uczyń swoje dziecko wyjątkowym, zapisując je
      <br />
      do żłobka Rudolf
    </h2>
    <div className="text-center">
      <a
        href="/kontakt"
        title="ZAPISZ DZIECKO DO RUDOLFA"
        style={{ color: '#000000', background: '#ffe401', padding: '20px 28px 18px' }}
        className="btn"
        role="button"
      >
        ZAPISZ SWOJE DZIECKO
      </a>
    </div>
  </div>
)

export default ContactHp
